import ReducerBuilder from "../../classes/ReducerBuilder";
import initialState from "./initialState";
import {Types} from "./actions";
import {isNoU} from "../../utils/DBUtils";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.START_UPLOAD_LOCATIONS)
    .reduce((state, action) => {
        state.uploading = true;
        state.brk = action.brk;
        state.resourcePath = action.resourcePath;
        state.fieldPath = action.fieldPath;
    })
    .forType(Types.END_UPLOAD_LOCATIONS)
    .reduce((state) => {
        state.uploading = false;
        state.brk = null;
        state.resourcePath = null;
        state.fieldPath = null;
    })
    .forType(Types.UPLOADED_LOCATIONS)
    .reduce((state, action) => {
        state.upload = action.upload;
        state.uploading = false;
        state.brk = null;
        state.resourcePath = null;
        state.fieldPath = null;
    })
    .forType(Types.RECEIVED_LOCATION_FILE)
    .reduce((state, action) => {
        if (isNoU(action.items) || action.items.length === 0) {
            return;
        }

        // Only most recent upload is relevant
        let mostRecent = action.items[0];
        for (let file of action.items) {
            if (file._created > mostRecent._created) {
                mostRecent = file;
            }
        }

        state.upload = mostRecent;
    })
    .build();

export default reducer;


// WEBPACK FOOTER //
// ./public/pages/StoreFinderImport/reducer.js